export const rowsPerPageOptions = [
  { value: 5, text: '5 Per Page' },
  { value: 10, text: '10 Per Page' },
  { value: 50, text: '50 Per Page' },
  { value: 100, text: '100 Per Page' },
  { value: 10000, text: 'All' },
];
